<ng-container [ngSwitch]="view">
    <span *ngSwitchCase="'normal'" class="badge badge-{{colorClass}} bg-{{colorClass}} text-white">BST</span>
    <fas *ngSwitchDefault class="small text-{{colorClass}}" i="check-circle"></fas>
</ng-container>
